import { AutoMap } from "@automapper/classes";

export class ReferenceClassificationsDto {

    @AutoMap()
  public id!: string;

    @AutoMap()
    public code!: string;

    @AutoMap()
    public description!: string;

}